import { useEffect } from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import StockStatesTable from './StockStatesTable'
import StockTransactionsTable from './StockTransactionsTable'
import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks'
import { resetActiveTab, setActiveTab, StockTabs } from '@state/reducers/stockReducer'

export function StocksTableTabs() {
  const dispatch = useAppDispatch()
  const { activeTab } = useAppSelector(({ stock }) => ({ activeTab: stock.activeTab }))

  return (
    <ToggleButtonGroup
      value={activeTab}
      exclusive
      color="primary"
      onChange={(_, value) => {
        value !== null && dispatch(setActiveTab(value))
      }}
      size="small"
      unselectable="off"
      className='m-3'
      sx={{
          '& .MuiToggleButton-root': {
            '&.Mui-selected': {
              backgroundColor: '#3A0CA1',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#3A0CA1',
              },
            },
          },
        }}
      >
      {[{ value: 0, label: 'État' }, { value: 1, label: 'Transactions' }].map(({ value, label }) => (
        <ToggleButton key={label} value={value}>
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

export default function StocksTable() {
  const dispatch = useAppDispatch()
  const { activeTab } = useAppSelector(({ stock }) => ({ activeTab: stock.activeTab }))

  useEffect(() => { 
    return () => {
      dispatch(resetActiveTab())
    }
  }, [])

  return (
    <>
      {activeTab === StockTabs.Stocks && (<StockStatesTable />)}
      {activeTab === StockTabs.Transactions && (<StockTransactionsTable />)}
    </>
  )
}
